import styled from "styled-components";

export const Wrapper = styled.div`
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
  position: absolute;
  height: 132x;
  min-height: 132px;
  width: 36px;
  min-width: 36px;
  bottom: 45px;
  left: 0px;
  z-index: 10;

  background: ${(props) => props.theme.colors.neutrals.primary[900]};
  border-radius: 6px;
  border: 1px solid
    ${(props) => props.theme.colors.neutrals.secondary.gray.stroke};

  /*Range Reset*/
  input[type="range"] {
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;

    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
    transform-origin: left;
    position: absolute;
    bottom: 0;
    width: 116px;
    height: 8px;
    left: 17px;
    border-radius: 100px;
    background: ${(props) => props.theme.colors.black};
  }

  /* Removes default focus */
  input[type="range"]:focus {
    outline: none;
  }

  /***** Chrome, Safari, Opera and Edge Chromium styles *****/
  /* slider track */
  input[type="range"]::-webkit-slider-runnable-track {
    background: ${(props) => props.theme.colors.black};
    border-radius: 4px;
    height: 4px;
  }

  /* slider thumb */
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    margin-top: -6px; /* Centers thumb on the track */

    /*custom styles*/
    background-color: ${(props) => props.theme.colors.neutrals.primary.white};
    border-radius: 50%;
    height: 16px;
    width: 16px;
  }

  input[type="range"]:focus::-webkit-slider-thumb {
  }

  /******** Firefox styles ********/
  /* slider track */
  input[type="range"]::-moz-range-track {
    background: ${(props) => props.theme.colors.black};
    border-radius: 4px;
    height: 4px;
  }

  /* slider thumb */
  input[type="range"]::-moz-range-thumb {
    border: none; /*Removes extra border that FF applies*/
    border-radius: 0; /*Removes default border-radius that FF applies*/

    /*custom styles*/
    background-color: ${(props) => props.theme.colors.neutrals.primary.white};
    border-radius: 50%;
    height: 16px;
    width: 16px;
  }

  input[type="range"]:focus::-moz-range-thumb {
  }
`;

export const Track = styled.div`
  z-index: 1;
  position: absolute;
  height: 10px;
  width: 4px;
  bottom: 4px;
  left: 15px;
  background-color: ${(props) => props.theme.colors.green[300].accent};

  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
`;
